import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
const PRODUCT = {
  title: 'Duerme, Bebé. Duerme.',
  edition: 'Guía Digital',
  price: '$6.39 USD',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/httGRv1CrMbBVj65D4mDnA/Mockup.png'
};
const NAMES = ['María G.', 'Ana L.', 'Sofía R.', 'Valentina M.', 'Camila P.', 'Isabella T.', 'Lucía H.', 'Daniela V.', 'Gabriela S.', 'Andrea C.', 'Carolina F.', 'Fernanda D.', 'Alejandra B.', 'Patricia N.', 'Laura E.', 'Mariana J.', 'Diana K.', 'Paola Q.', 'Natalia W.', 'Claudia Z.', 'Rosa M.', 'Elena P.', 'Adriana L.', 'Mónica R.', 'Verónica S.', 'Jessica T.', 'Karla V.', 'Lorena H.', 'Sandra G.', 'Alicia F.'];
const CITIES = ['Miami, FL', 'Houston, TX', 'Los Angeles, CA', 'San Antonio, TX', 'Chicago, IL', 'Phoenix, AZ', 'Dallas, TX', 'San Diego, CA', 'New York, NY', 'Denver, CO', 'Orlando, FL', 'Las Vegas, NV', 'Austin, TX', 'San Jose, CA', 'Tampa, FL', 'El Paso, TX', 'Tucson, AZ', 'Albuquerque, NM', 'Sacramento, CA', 'Atlanta, GA', 'Charlotte, NC', 'Fresno, CA', 'Riverside, CA', 'Newark, NJ', 'Fort Worth, TX', 'Bakersfield, CA', 'Hialeah, FL', 'Laredo, TX', 'Brownsville, TX', 'McAllen, TX'];
function getRandomInterval() {
  return Math.floor(Math.random() * 25000) + 20000; // 20-45 seconds
}
export function RecentPurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  const recentNames = useRef<string[]>([]);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const shouldReduceMotion = useReducedMotion();
  const pickName = useCallback(() => {
    const available = NAMES.filter(n => !recentNames.current.includes(n));
    const pool = available.length > 0 ? available : NAMES;
    const name = pool[Math.floor(Math.random() * pool.length)];
    recentNames.current.push(name);
    if (recentNames.current.length > 10) {
      recentNames.current.shift();
    }
    return name;
  }, []);
  const showNotification = useCallback(() => {
    const name = pickName();
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name,
      city
    });
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
    // Schedule next
    timerRef.current = setTimeout(() => {
      showNotification();
    }, getRandomInterval() + 4000); // wait for hide + random interval
  }, [pickName]);
  useEffect(() => {
    // First notification after 3 seconds
    timerRef.current = setTimeout(() => {
      showNotification();
    }, 3000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [showNotification]);
  const animationProps = shouldReduceMotion ? {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.15
    }
  } : {
    initial: {
      opacity: 0,
      y: 60,
      scale: 0.95
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      y: 60,
      scale: 0.95
    },
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 30
    }
  };
  return <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none" data-id="element-383">
      <AnimatePresence data-id="element-384">
        {visible && <motion.div {...animationProps} className="pointer-events-auto bg-white rounded-2xl shadow-2xl border border-gray-100 px-4 py-3 flex items-center gap-4 max-w-sm w-[340px] sm:w-[380px]" data-id="element-385">
            <img src={PRODUCT.thumbnail} alt={PRODUCT.title} className="w-14 h-14 rounded-xl object-cover flex-shrink-0 shadow-sm" data-id="element-386" />
            <div className="flex-grow min-w-0" data-id="element-387">
              <p className="text-sm text-texto leading-snug" data-id="element-388">
                <span className="font-bold text-azul-noche" data-id="element-389">
                  {notification.name}
                </span>{' '}
                en <span className="font-medium" data-id="element-390">{notification.city}</span>
              </p>
              <p className="text-sm text-texto/80 mt-0.5" data-id="element-391">
                compró{' '}
                <span className="font-semibold text-azul-noche" data-id="element-392">
                  {PRODUCT.edition}
                </span>
                {' — '}
                <span className="font-bold text-lila-suave" data-id="element-393">
                  {PRODUCT.price}
                </span>
              </p>
              <p className="text-xs text-texto/40 mt-1" data-id="element-394">
                hace {Math.floor(Math.random() * 12) + 1} min
              </p>
            </div>
            <div className="flex-shrink-0" data-id="element-395">
              <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-396"></div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}